import { format } from "date-fns";
import React from "react";

import { Text } from "@whoosh/design-system/src/components/primitive";
import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

type Props = {
  monthDateObj: Date;
  clubWeekStartsOn: NumericalDayOfWeek;
};

export const MonthNameHeader = ({ monthDateObj, clubWeekStartsOn }: Props) => {
  const monthName = format(monthDateObj, "MMMM yyyy", {
    weekStartsOn: clubWeekStartsOn,
  });
  return (
    <Text variant="mainSmallSemiBold" textAlign={"center"} paddingVertical={4}>
      {monthName}
    </Text>
  );
};
